<template>
	<div class="box" style="border-radius: 13px;
    box-shadow: rgb(0 0 0 / 3%) 0px 4px 12px;">
		<div class="null-page" v-show="yes"></div>
		
		<div class="security" v-loading="loading" style="border-radius: 13px;
    box-shadow: rgb(0 0 0 / 3%) 0px 4px 12px;">
			<div class="item-wrap" v-if="type == 'all'">
				<div class="item">
					<div class="item-content">
						<i class="iconfont iconxiugaidenglumima"></i>
						<div class="name-wrap">
							<div class="name" style="    font-weight: 600;     font-size: 15px; " >เปลียนรหัสผ่าน</div>
							<div class="content" style="color: #0000007d;
    font-weight: 500;">บัญชีอินเทอร์เน็ตมีความเสี่ยงจากการโจรกรรม เราขอแนะนําให้คุณเปลี่ยนรหัสผ่านเป็นระยะๆ เพื่อปกป้องบัญชีของคุณ</div>
						</div>
					</div>
					<div class="btn" style="    font-family: 'Prompt';"><el-button type="primary" style="    font-family: 'Prompt';" size="medium" @click="edit('password')">แก้ไข</el-button></div>
				</div>
				<!-- <div class="item">
					<div class="item-content">
						<i class="iconfont iconyouxiang1"></i>
						<div class="name-wrap">
							<div class="name">การผูกกล่องจดหมาย</div>
							<div class="content">หลังจากการตรวจสอบ，สามารถใช้เพื่อดึงรหัสผ่านเข้าสู่ระบบและรหัสผ่านการชําระเงินได้อย่างรวดเร็ว</div>
						</div>
					</div>
					<div class="btn"><el-button type="primary" size="medium" @click="edit('email')">แก้ไข</el-button></div>
				</div> -->
				<div class="item">
					<div class="item-content">
						<i class="iconfont iconshoujiyanzheng"></i>
						<div class="name-wrap">
							<div class="name" style="    font-weight: 600;     font-size: 15px;">ยืนยันบัญชีทางโทรศัพท์</div>
							<div class="content" style="color: #0000007d;
    font-weight: 500;" >หลังจากการตรวจสอบ สามารถใช้เพื่อดึงรหัสผ่านเข้าสู่ระบบและรหัสผ่านการชําระเงินได้อย่างรวดเร็ว </div>
						</div>
					</div>
					<div class="btn"><el-button type="primary" style="    font-family: 'Prompt';" size="medium" @click="edit('tell')">แก้ไข</el-button></div>
				</div>
			<!-- 	<div class="item">
					<div class="item-content">
						<i class="el-icon-lock"></i>
						<div class="name-wrap">
							<div class="name">รหัสผ่านการชําระเงิน</div>
							<div class="content">การชําระเงินทางอินเทอร์เน็ตมีความเสี่ยงจากการโจรกรรม，เราขอแนะนําให้คุณเปลี่ยนรหัสผ่านการชําระเงินเป็นประจําเพื่อปกป้องบัญชีของคุณ</div>
						</div>
					</div>
					<div class="btn"><el-button type="primary" size="medium" @click="edit('payPassWord')">แก้ไข</el-button></div>
				</div> -->
			</div>
			<div class="edit" v-if="type == 'password'">
				<div class="title">แก้ไขรหัสผ่านเข้าสู่ระบบ</div>
				<div v-if="memberInfo.password">
					<div class="pass-form">
						<el-form :model="passWordForm" :rules="passWordRules" ref="passWordRef" label-width="100px">
							<el-form-item label="รหัสผ่านเดิม" prop="oldPass"><el-input type="password" placeholder="รหัสผ่านปัจจุบัน" v-model="passWordForm.oldPass"></el-input></el-form-item>
							<el-form-item label="รหัสผ่านใหม่" prop="pass"><el-input type="password" placeholder="รหัสผ่านใหม่" v-model="passWordForm.pass"></el-input></el-form-item>
							<el-form-item label="ยืนยันรหัสผ่าน" prop="checkPass">
								<el-input type="password" placeholder="โปรดยืนยันรหัสผ่านใหม่" v-model="passWordForm.checkPass"></el-input>
							</el-form-item>
						</el-form>
					</div>
					<div class="btn">
						<el-button type="primary" @click="save">ประหยัด</el-button>
						<el-button @click="type = 'all'">ยกเลิก</el-button>
					</div>
				</div>
				<div v-else class="tell-pass">
					<el-form :model="tellPassForm" :rules="tellPassRules" ref="tellPassRef" label-width="100px">
						<el-form-item label="รหัสยืนยัน" prop="code">
							<el-input placeholder="กรุณากรอกรหัสยืนยัน" maxlength="4" v-model="tellPassForm.code">
								<template slot="append">
									<img :src="captcha.img" mode class="captcha" @click="getcaptcha" />
								</template>
							</el-input>
						</el-form-item>
						<el-form-item label="รหัสแบบไดนามิก" prop="tellPassDynacode">
							<el-input placeholder="กรุณาใส่รหัสแบบไดนามิก" v-model="tellPassForm.tellPassDynacode">
								<template slot="append">
									<el-button type="primary" @click="getTellPassCode">{{ tellPassForm.tellPassCodeText }}</el-button>
								</template>
							</el-input>
						</el-form-item>
						<p class="tell-code">คลิก“รับรหัสแบบไดนามิก”，หมายเลขโทรศัพท์ที่ถูกผูกไว้ของคุณจะถูกออกให้{{ memberInfo.mobile | mobile }}ส่งรหัสยืนยัน</p>
						<el-form-item label="รหัสผ่านใหม่" prop="pass"><el-input type="password" placeholder="รหัสผ่านใหม่" v-model="tellPassForm.pass"></el-input></el-form-item>
						<el-form-item label="ยืนยันรหัสผ่าน" prop="checkPass"><el-input type="password" placeholder="โปรดยืนยันรหัสผ่านใหม่" v-model="tellPassForm.checkPass"></el-input></el-form-item>
					</el-form>
					<div class="btn">
						<el-button type="primary" @click="tellPassSave">ประหยัด</el-button>
						<el-button @click="type = 'all'">ยกเลิก</el-button>
					</div>
				</div>
			</div>
			<div class="edit" v-if="type == 'email'">
				<div class="title">ผูกกล่องจดหมาย</div>
				<div class="pass-form">
					<el-form :model="emailForm" :rules="emailRules" ref="emailRef" label-width="100px">
						<el-form-item label="กล่องจดหมายปัจจุบัน" prop="email" v-if="emailForm.currEmail">
							<p>{{ emailForm.currEmail }}</p>
						</el-form-item>
						<el-form-item label="ตู้จดหมาย" prop="email"><el-input type="email" placeholder="请输入ตู้จดหมาย" v-model="emailForm.email"></el-input></el-form-item>
						<el-form-item label="รหัสยืนยัน" prop="code">
							<el-input placeholder="กรุณากรอกรหัสยืนยัน" maxlength="4" v-model="emailForm.code">
								<template slot="append">
									<img :src="captcha.img" mode class="captcha" @click="getcaptcha" />
								</template>
							</el-input>
						</el-form-item>
						<el-form-item label="รหัสแบบไดนามิก" prop="emailDynacode">
							<el-input placeholder="กรุณาใส่รหัสแบบไดนามิก" v-model="emailForm.emailDynacode">
								<template slot="append">
									<el-button type="primary" @click="getEmailCode">{{ emailForm.emailCodeText }}</el-button>
								</template>
							</el-input>
						</el-form-item>
					</el-form>
				</div>
				<div class="btn">
					<el-button type="primary" @click="bindEmail">ประหยัด</el-button>
					<el-button @click="type = 'all'">ยกเลิก</el-button>
				</div>
			</div>
			<div class="edit" v-if="type == 'tell'">
				<div class="title">ผูกหมายเลขโทรศัพท์</div>
				<div class="pass-form">
					<el-form :model="tellForm" :rules="tellRules" ref="tellRef" label-width="100px">
						<el-form-item label="หมายเลขโทรศัพท์ปัจจุบัน" prop="email" v-if="tellForm.currTell">
							<p>{{ tellForm.currTell }}</p>
						</el-form-item>
						<el-form-item label="หมายเลขโทรศัพท์มือถือ" prop="tell"><el-input type="tell" placeholder="请输入หมายเลขโทรศัพท์มือถือ" v-model="tellForm.tell"></el-input></el-form-item>
						<el-form-item label="รหัสยืนยัน" prop="code">
							<el-input placeholder="กรุณากรอกรหัสยืนยัน" maxlength="4" v-model="tellForm.code">
								<template slot="append">
									<img :src="captcha.img" mode class="captcha" @click="getcaptcha" />
								</template>
							</el-input>
						</el-form-item>
						<el-form-item label="รหัสแบบไดนามิก" prop="tellDynacode">
							<el-input placeholder="กรุณาใส่รหัสแบบไดนามิก" v-model="tellForm.tellDynacode">
								<template slot="append">
									<el-button type="primary" @click="gettellCode">{{ tellForm.tellCodeText }}</el-button>
								</template>
							</el-input>
						</el-form-item>
					</el-form>
				</div>
				<div class="btn">
					<el-button type="primary" @click="bindtell">ประหยัด</el-button>
					<el-button @click="type = 'all'">ยกเลิก</el-button>
				</div>
			</div>
			<div class="edit-pay" v-if="type == 'payPassWord'">
				<div class="title">ผูกรหัสผ่านการชําระเงิน</div>
				<div class="container">
					<div class="name" v-if="step != 0">กรุณากรอก6รหัสผ่านการชําระเงินบิต，ไม่แนะนําให้ใช้ตัวเลขซ้ําหรือต่อเนื่องกัน</div>
					<div class="name" v-else-if="isSend">รหัสยืนยันได้ถูกส่งไปยังแล้ว{{ tellForm.currTell | mobile }}</div>
					<div class="password-wrap">
						<el-input :maxlength="step == 0 ? 4 : 6" @change="input" ref="input" :auto-focus="true" v-model="payInput" :placeholder="palceText" v-if="step == 0"></el-input>
						<el-input
							:maxlength="step == 0 ? 4 : 6"
							@change="input"
							ref="input"
							:auto-focus="true"
							v-model="payInput"
							type="password"
							:placeholder="palceText"
							v-else
						></el-input>
						<div v-show="step == 0" class="dynacode" @click="sendMobileCode">{{ payCodeText }}</div>
					</div>
				</div>
				<div class="btn">
					<el-button type="primary" @click="bindPayPwd" :disabled="isClick">ประหยัด</el-button>
					<el-button @click="type = 'all'">ยกเลิก</el-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import security from './security';
export default {
	name: 'security',
	mixins: [security]
};
</script>
<style lang="scss" scoped>
.box {
	width: 100%;
	position: relative;
}

.null-page {
	width: 100%;
	height: 730px;
	background-color: #FFFFFF;
	position: absolute;
	top: 0;
	left: 0;
	z-index: 9;
}	

.security {
	background: #ffffff;
	.el-form {
		margin: 0 30px;
		.captcha {
			vertical-align: top;
			max-width: inherit;
			width: 74px;
			max-height: 38px;
			line-height: 38px;
			cursor: pointer;
		}
	}
	.item {
		border-bottom: 1px solid #f1f1ff;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 20px;
		.item-content {
			display: flex;
			align-items: center;
			i {
				font-size: 40px;
			}
			.name-wrap {
				margin-left: 20px;
			}
		}
	}
	.edit {
		padding: 20px;
		.title {
			padding-bottom: 5px;
			font-size: $ns-font-size-base;
			border-bottom: 1px solid #f1f1f1;
		}
		.pass-form {
			margin-top: 20px;
			display: flex;
			justify-content: center;
			.el-form {
				width: 500px;
			}
		}
		.btn {
			display: flex;
			justify-content: center;
		}
	}
	.tell-pass {
		margin-top: 20px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		.el-form {
			width: 500px;
		}
		.tell-code {
			margin-left: 66px;
			margin-bottom: 20px;
		}
	}
	.edit-pay {
		padding: 20px;
		text-align: center;
		.title {
			font-size: $ns-font-size-base;
			border-bottom: 1px solid #f1f1f1;
			text-align: left;
			padding-bottom: 5px;
		}
		.dynacode {
			cursor: pointer;
			text-align: right;
			margin-right: 329px;
			color: $base-color;
			margin-bottom: 20px;
		}
		.el-input {
			width: 300px;
			margin-top: 20px;
		}
		.btn {
			margin-top: 20px;
		}
		.name {
			margin-top: 10px;
		}
	}
}
</style>
